import Config from 'services/config/local';

// noinspection JSUnresolvedVariable,Eslint
if (!ENVIRONMENT || ['development', 'test'].indexOf(ENVIRONMENT)) {
    require('./priveleges.json'); // eslint-disable-line global-require
}

/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    return response.data;
}

/**
 * PrivilegesApi class.
 */
export default class PrivilegesApi {
    /**
     * @param {$http} $http - Angular $http service
     * @constructor
     * @ngInject
     */
    constructor($http) {
        this.$http = $http;
        this.config = Config.api.privileges;
    }

    /**
     * Get Privileges
     * @returns {promises}
     */
    getList() {
        return this.$http.get(this.config.listUrl).then(responseDataExtractor);
    }
}



// WEBPACK FOOTER //
// ./app/services/api/privileges/privileges.service.js